module.exports = __webpack_public_path__ + "static/media/plugNegative.4f7f4f41.svg";